<app-standard-bottom-sheet [isOpen]="isOpen()"
                          [isFullScreen]="true"
                          [preventOverlayClose]="hasUnsavedChanges"
                          (isOpenChange)="onSheetOpenChange($event)"
                          (overlayClick)="onDismissRequested()"
                          testId="checklist-issue-sheet">

  <app-section-header [title]="title()"
                      align="center"
                      testId="checklist-issue-sheet" />


  <form [formGroup]="form"
        class="checklist-issue-form"
        data-testid="checklist-issue-sheet-form">
  <p class="assertion-text"
     [innerHTML]="assertionText()"
     data-testid="checklist-issue-sheet-text-assertion"></p>

    @if (showRoomField()) {
      <app-form-field label="Room"
                      inputId="checklist-issue-room"
                      [required]="true"
                      [control]="form.controls.lotAreaIdentifier"
                      [errorMessages]="{ required: 'Room is required.' }"
                      testId="checklist-issue-sheet-room">
        <app-select-field inputId="checklist-issue-room"
                          formControlName="lotAreaIdentifier"
                          [options]="areas()"
                          optionLabel="name"
                          optionValue="identifier"
                          placeholder="Select Room"
                          [invalid]="isInvalid('lotAreaIdentifier')"
                          testId="checklist-issue-sheet-room-select" />
      </app-form-field>
    }

    <app-form-field label="Add Photos"
                    [required]="true"
                    [labelSuffix]="'(Max ' + maxPhotos + ')'"
                    [control]="form.controls.photos"
                    [invalid]="isInvalid('photos')"
                    [errorMessages]="{ required: 'At least one photo is required.' }"
                    testId="checklist-issue-sheet-photos">
      <app-photo-capture inputId="checklist-issue-sheet"
                         [images]="photoThumbnails()"
                         [invalid]="isInvalid('photos')"
                         [disabled]="imageCompressionPipelineService.isCompressingImages()"
                         [loading]="imageCompressionPipelineService.isLoadingImages()"
                         [optimizing]="imageCompressionPipelineService.isCompressingImages()"
                         [processingCount]="imageCompressionPipelineService.numberOfImagesBeingProcessed()"
                         (filesSelected)="onPhotosSelected($event)"
                         (imageClicked)="openImagesModal($event)"
                         testId="checklist-issue-sheet-photo" />
    </app-form-field>

    <app-form-field label="Notes"
                    inputId="checklist-issue-notes"
                    [required]="true"
                    [control]="form.controls.notes"
                    [invalid]="isInvalid('notes')"
                    [maxLength]="maxNoteLength"
                    [errorMessages]="{ required: 'Notes are required.' }"
                    testId="checklist-issue-sheet-notes">
      <app-textarea inputId="checklist-issue-notes"
                    formControlName="notes"
                    placeholder="Describe the item..."
                    [maxLength]="maxNoteLength"
                    [showCount]="false"
                    [invalid]="isInvalid('notes')"
                    testId="checklist-issue-sheet-textarea-notes" />
    </app-form-field>
  </form>

  <app-vertical-button-group [buttons]="footerButtons"
                             testId="checklist-issue-sheet-footer" />
</app-standard-bottom-sheet>

<app-add-area-dialog [visible]="addRoomSheetOpen()"
                     (visibleChange)="onAddRoomSheetVisibleChange($event)"
                     [areasConfig]="areasConfig()"
                     [existingAreas]="roomOptions()"
                     [zoneOptions]="zoneOptions()"
                     [isSaving]="savingRoom()"
                     [slideIn]="true"
                     (addArea)="roomSubmitted.emit($event)"
                     data-testid="checklist-issue-sheet-add-room" />
